export abstract class StorageEntries
{
	private static readonly PREFIX: string = "storebook__"

	private static readonly PROFILE_KEY: string = StorageEntries.PREFIX + "profile"

	public static readProfile = (): string => {
		const info: string|null = localStorage.getItem(StorageEntries.PROFILE_KEY)
		if(info !== "ADMIN" && info !== "BRAND") {
			return "ADMIN"
		}

		return info
	}

	public static saveProfile = (profile: string): void => {
		localStorage.setItem(StorageEntries.PROFILE_KEY, profile)
	}

	public static clearSession = (): void => {
		sessionStorage.removeItem(StorageEntries.PROFILE_KEY)
	}
}
